import { useTranslation } from 'appState';
import { fillTranslationTextWithVariables } from 'hooks';
import ReactMarkdown from 'react-markdown';
import { AssessmentResults } from 'types';

type CognitiveStrength = {
  id: 'memory' | 'adaptability' | 'attention' | 'problemSolving' | 'speed' | 'persistence';
  score: number;
  name: string;
}

type SegmentationFeedbackProps = {
  username: string;
  results?: AssessmentResults | null;
  cognitiveStrengths?: CognitiveStrength[] | null;
}

const SegmentationFeedback: React.FC<SegmentationFeedbackProps> = ({
  username,
  results,
  cognitiveStrengths
}) => {
  const lang = useTranslation('GamesCompleted');

  if (results?.isEnt === undefined) return <>{lang.message}</>;

  const message = fillTranslationTextWithVariables(
    results.isEnt ? lang.messageEnt : lang.messageWage, { username }
  );

  let skillsMessage = '';
  if (cognitiveStrengths && cognitiveStrengths.length > 0) {
    const { length } = cognitiveStrengths;
    const isEnt = results.isEnt;
    const skills = {
      skill1: cognitiveStrengths[0]?.name ?? '',
      skill2: cognitiveStrengths[1]?.name ?? '',
      skill3: cognitiveStrengths[2]?.name ?? '',
    };

    let key;
    if (length === 1) {
      key = isEnt ? 'messageEntSkills1' : 'messageWageSkills1';
    } else if (length === 2) {
      key = isEnt ? 'messageEntSkills2' : 'messageWageSkills2';
    } else {
      key = isEnt ? 'messageEntSkills' : 'messageWageSkills';
    }

    const messageTemplate = (lang as Record<string, string>)[key];
    skillsMessage = fillTranslationTextWithVariables(
      messageTemplate || (isEnt ? lang.messageEntSkills : lang.messageWageSkills), skills
    );
  }

  return (
    <>
      <ReactMarkdown unwrapDisallowed>
        {message}
      </ReactMarkdown>
      <br />
      <ReactMarkdown unwrapDisallowed>
        {skillsMessage}
      </ReactMarkdown>
    </>
  );
};

export default SegmentationFeedback;
